import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SpaceBetween } from "@amzn/awsui-components-react";

import { RootState } from "../../app/rootReducer";
import { trackComponentView } from "../../telemetry/telemetry";
import {
  cancelAllProgramTicketsRequests,
  fetchProgramTickets,
  setProgramTicketsPage,
} from "./programTicketsConnector";
import { ProgramTicketsTable } from "./ProgramTicketsTable";
import { TicketDetailsPanel } from "./TicketDetailsPanel";

export const ProgramTicketsTabContent: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch = useDispatch<any>();

  const queryString = useSelector(
    (state: RootState) => state.generateQuery.queryString
  );
  const selectedCount = useSelector(
    (state: RootState) => state.programTickets.selectedTicketIds.length
  );

  const isZeroState = queryString === "" || queryString === "(all)";

  useEffect(() => {
    trackComponentView("programTickets", "view");
  }, []);

  useEffect(() => {
    if (isZeroState) {
      return;
    }
    const controller = new AbortController();
    // Reset the stored page alongside the fetch so <Pagination>'s
    // currentPageIndex tracks the page actually loaded — otherwise
    // state.page stays at whatever the user was on before the filter
    // changed while the table renders fresh page-0 rows.
    dispatch(setProgramTicketsPage(0));
    dispatch(
      fetchProgramTickets({
        searchQueryString: queryString,
        page: 0,
        signal: controller.signal,
      })
    );
    return () => {
      controller.abort();
    };
  }, [dispatch, queryString, isZeroState]);

  useEffect(() => {
    return () => {
      dispatch(cancelAllProgramTicketsRequests());
    };
  }, [dispatch]);

  return (
    <SpaceBetween size="l">
      <ProgramTicketsTable />
      {selectedCount > 0 ? <TicketDetailsPanel /> : null}
    </SpaceBetween>
  );
};

export default ProgramTicketsTabContent;
